var styles = {
  "ListItem": "Online-Store-UI-Dropdown__ListItem_ff318",
  "active": "Online-Store-UI-Dropdown--active_8ksq4",
  "SelectedCheck": "Online-Store-UI-Dropdown__SelectedCheck_10x00"
};

export { styles as default };
